import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ReactComponent as CloseBtn } from './../../../../assets/icons/close.svg';


import PostLoginPostApi from "../../../../components/Api/PostLoginPostApi";
import Button from "../../../../components/Button";

import PostLoginGetApi from "../../../../components/Api/PostLoginGetApi";
import init from "../../AccessControl/Check";
import './createBrand.css';
import { MAX_UPLOAD_FILE_SIZE } from "../../../../components/Constants/FileUpload";
import $ from 'jquery';



const CreateBrand = () => {
    const pageName = "Voucher Brand Add";
    const isAccess = init(pageName);

    const navigate = useNavigate();


    const fileInput = useRef();
    const fileInput2 = useRef();

    const [file, setFile] = useState();
    const [file2, setFile2] = useState();

    const [input, setInput] = useState({
        category_id: "",
        name: "",
        logo: "",
        banner: "",
        description: "",
        position: ""
    });

    const selectFile = () => {
        fileInput.current.click();
    }

    const selectFile2 = () => {
        fileInput2.current.click();
    }

    const handleChange = (e) => {
        if( !e.target?.files[0] ) {
            return;
        }
        
        if(e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        }

        if (!e.target.files[0]["type"].includes("image/")) {
            toast.error("Please upload valid Image file.");
            return;
        }

        setFile(e.target.files[0]);
    }

    const handleChange2 = (e) => {
        if( !e.target?.files[0] ) {
            return;
        }
        
        if(e.target.files[0]["size"] > MAX_UPLOAD_FILE_SIZE) {
            toast.error("Max upload file size is 1 MB.");
            return;
        } 

        

        
        if (!e.target.files[0]["type"].includes("image/")) {
            toast.error("Please upload valid Image file.");
            return;
        }

        setFile2(e.target.files[0]);
    }

    const [companyId, setCompanyId] = useState(0);
    const [categoryList, setCategoryList] = useState([]);
    const [featuredBrandsList, setFeaturedBrandsList] = useState([]);

    useEffect(() => {

        setCompanyId(JSON.parse(localStorage.getItem('CompanyId')));


        // Voucher Category List
        PostLoginGetApi("voucher/category", "", 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setCategoryList(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        });



        // Voucher Featured Brands Top 10
        PostLoginGetApi("voucher/brand/all-featured/top-10", "", 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setFeaturedBrandsList(responseData["data"]);
                }
            }
        }).catch((err) => {
            console.log(err);
        });



    }, []);



    const [isFeatured, setIsFeatured] = useState(0);
    const submitFormData = (event) => {
        event.preventDefault();

        const btn_submit = "button[type='submit']";
        $(btn_submit).html("Please wait...");
        $(btn_submit).attr("disabled", true);

        if (file === undefined || file2 === undefined) {
            toast.error("Please upload Banner and Logo !");
            return;
        }

        let requestBody = new FormData();
        requestBody.append("category_id", input.category_id);
        requestBody.append("name", input.name);
        requestBody.append("logo", file2);
        requestBody.append("banner", file);
        requestBody.append("description", input.description);
        requestBody.append("is_featured", isFeatured);
        requestBody.append("position", input.position);


        PostLoginPostApi("voucher/brand/add", requestBody, 1, 1).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    toast.success("Brand added successfully.");
                    return navigate("/dashboard/voucher", {
                        state: {
                            tab: "brand"
                        }
                    });
                }

                toast.error(responseData["messages"].toString());
            }
        }).catch((error) => {
            toast.error("A problem occur. Please try again.");
            console.log(error);
        }).finally(() => {
            $(btn_submit).html("Add Voucher Brand");
            $(btn_submit).attr("disabled", false);
            return;
        });
    }

    const handleInputChange = (evt) => {
        const value = evt.target.value;

        if( evt.target.name === "position") {
            if( isNaN(value) || value.includes(".") ) {
                return;
            }
        }

        setInput({ ...input, [evt.target.name]: value });
    }

    const handleIsFeatured = (event) => {
        let is_featured = event.currentTarget.value;
        setIsFeatured(is_featured);

        setInput({...input, position: ""});

        if( is_featured === "1" ) {
            $("#position_div").show();
            $("#position").attr("required", true);
            return;
        }

        $("#position_div").hide();
        $("#position").attr("required", false);
    }
    


    if (isAccess === false) {
        return (<>
            <table className="custom-details-table w-full mt-0 mb-2">
                <tbody>
                    <tr>
                        <td className="font-semibold text-base">
                            You do not have any access !
                        </td>
                    </tr>
                </tbody>
            </table>
        </>);
    }


    return (
        <div className="font-medium min-h-[100vh] w-[100%] h-[100%] custom-container-left custom-scroll-auto">
            <div className="font-medium pb-[60px]">
                <header className="flex justify-between items-center p-4 border-b-2 border-dark-white mb-[60px]">
                    <Link to="/dashboard/voucher" state={{ tab: "brand" }}><CloseBtn /></Link>
                    <p className="text-xl text-black m-auto">Create Voucher Brand</p>
                </header>
                <main className="max-w-2xl m-auto">
                    <div className="flex justify-center ">
                        <form action='' autoComplete="off" method='POST' className="w-full" onSubmit={(event) => submitFormData(event)} >


                            <div className="py-2 mt-1 relative">
                                <select name="category_id" id="category_id" value={input.category_id} onChange={handleInputChange} className="w-full rounded border-solid border border-dark-white " required>
                                    <option value="" hidden>Select category *</option>
                                    {categoryList.map((data, index) => (
                                        <option key={index} value={data.id} className='text-black'>{data.name}</option>

                                    ))}
                                </select>

                                <label htmlFor="storeCategory" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:opacity-100 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Category</label>
                            </div>


                            <div className="relative py-2 mb-1">
                                <input type="text" name="name" id="name" value={input.name} onChange={handleInputChange} title="Name" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />

                                <label htmlFor="name" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Brand Name *</label>
                            </div>

                            
                            <div className="flex pb-2 pt-1 mb-1 items-center">
                                <div className="flex items-center relative w-[49.5%] bg-[#f5f5f5] p-2 rounded-md ml-auto order-2" style={{ border: "1px solid #e0e0e0" }}>
                                    <input type="file" className="hidden" name="logo" ref={fileInput2} onChange={handleChange2} />
                                    <label htmlFor="logo" className="p-1 text-base font-medium">Brand Logo *</label>
                                    {file2 ?
                                        <>
                                            {file2["type"].includes("image/")
                                                ? <img src={URL.createObjectURL(file2)} alt="Preview Logo" className="max-h-8 max-w-6 ml-auto order-3" />
                                                : <span className="text-xs pr-3">{file2["name"]}</span>
                                            }
                                            <button type="button" className="text-white ml-auto order-3 bg-[#444] py-[10px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs" onClick={selectFile2}>Change</button>
                                        </> :
                                        <>
                                            <button type="button" className="text-white ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer block justify- text-base" onClick={selectFile2}>Upload Logo</button>
                                        </>
                                    }

                                </div>
                                
                                <div className="flex items-center relative w-[49.5%] bg-[#f5f5f5] p-2 rounded-md" style={{ border: "1px solid #e0e0e0" }}>
                                    <input type="file" name="banner" className="hidden" ref={fileInput} onChange={handleChange} />
                                    <label htmlFor="banner" className="p-1 text-base font-medium">Brand Banner *</label>

                                    {file ?
                                        <>
                                            {file["type"].includes("image/")
                                                ? <img src={URL.createObjectURL(file)} alt="Preview Banner" className="max-h-8 max-w-[150px] ml-auto order-3" />
                                                : <span className="text-xs pr-3">{file["name"]}</span>
                                            }
                                            <button type="button" className="text-white ml-auto order-3 bg-[#444] py-[10px] px-[10px] rounded-[3px] cursor-pointer block justify- text-xs" onClick={selectFile}>Change</button>
                                        </> :
                                        <>
                                            <button type="button" className="text-white ml-auto order-2 bg-[#1A202C] py-[10px] px-[25px] rounded-[3px] cursor-pointer block justify- text-base" onClick={selectFile}>Upload Banner</button>
                                        </>}
                                </div>

                            </div>

                            <div className="relative pb-2 pt-1 mb-4 mt-2">
                                <input type="text" name="description" id="description" value={input.description} onChange={handleInputChange} title="Description" placeholder=" " className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" />

                                <label htmlFor="description" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Campaign Title</label>
                            </div>


                            <div className="flex border-zinc-200 border py-1 px-3 my-3 rounded-md">
                                <div className="flex h-[40px] bg-white items-center w-auto">
                                    <p className="text-[16px] font-semibold">
                                        Is Featured ?
                                    </p>

                                    <span className="flex ml-4 mr-2">
                                        <label htmlFor="is_featured_yes" className="flex items-center z-10 w-auto px-3 cursor-pointer">
                                            <input type="radio" name="is_featured" id="is_featured_yes" onChange={handleIsFeatured} value="1" />
                                            <span></span>
                                            <span className="py-2 text-md inline-block w-max">Yes</span>
                                        </label>

                                        <label htmlFor="is_featured_no" className="flex items-center w-full z-10 cursor-pointer">
                                            <input type="radio" name="is_featured" id="is_featured_no" value="0" onChange={handleIsFeatured} defaultChecked />
                                            <span></span>
                                            <span className="py-2 text-md inline-block">No</span>
                                        </label>
                                    </span>
                                </div>
                            </div>


                            <div className="relative pb-2 pt-1 mb-4 w-1/2 pr-4 hidden" id="position_div">
                                <input type="text" name="position" id="position" value={input.position} onChange={handleInputChange} title="Position" maxLength={4} placeholder=" " className="pl-[10px] w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" />

                                <label htmlFor="position" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Brand Position *</label>
                            </div>




                            <Button name="Add Voucher Brand"></Button>

                        </form>
                    </div>
                </main>

                {/* Existing Top 10 Featured List */}
                {featuredBrandsList.length > 0 && 
                    <table id="right-section" className="divide-y divide-gray-200 custom-table-hover">
                        <thead className='bg-neutral-100'>
                            <tr className='text-left'>
                                <th scope="col" className="px-4 py-2 text-center w-16 border-r-2">#</th>
                                <th scope="col" className="px-4 py-2">Top 10 Featured Brand</th>
                            </tr>
                        </thead>
                        <tbody>
                            {featuredBrandsList.map((val, index)=>
                                <tr className='border-b-2' key={index}>
                                    <td className="text-center border-r-2">{index+1}</td>
                                    <td className="px-4 py-2">
                                        {(companyId === val.company_id) ? <strong>{val.name}</strong> : <>{val.name}</> }
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                }


            </div>

            <style>{`
                * :disabled {
                    color: rgb(0, 0, 0, .9);
                    border: 1px solid rgb(0, 0, 0, .2);
                    background-color: #F5F5F5 !important;
                    cursor: wait;
                }

                #right-section {
                    top: 125px; 
                    position: absolute;
                    right: 0;
                    margin-right: 30px;
                    width: 450px;
                }


                @media only screen and (max-width: 1620px) { 
                    #right-section {
                        top: 125px;
                        position: static;
                        right: 0;
                        margin-right: 30px;
                        margin: auto;
                        width: 675px;
                    }
                }


                label > input[type='radio'], input[type="radio"] {
                    display: none;
                }

                label > input[type="radio"] + *::before {
                    color: #158560 !important;
                    content: " ";
                    display: inline-grid;
                    width: 1.1rem;
                    height: 1.1rem;
                    border-radius: 50%;
                    border-style: solid;
                    border-width: 0.1rem;
                    border-color: #158560;
                    margin-top: 5px;
                }

                label > input[type="radio"]:checked + *::before {
                    background: radial-gradient(#158560 0%, #158560 40%, transparent 50%, transparent);;
                    border-color: #158560;
                }

                label > input[type="radio"] + * {
                    display: inline-block;
                    padding: 0.5rem;
                }


            `}</style>

        </div>
    );
};

export default CreateBrand;